export const LoadingPlaces = () => {
  return (
    <div className="alert mt-2 text-center alert-primary">
      <h6>Searching</h6>
      <p>Please wait</p>
    </div>
  );
};
